import '../styles';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Providers } from '../state/Providers';
import { router } from '../routes/router';

createRoot(document.getElementById('root')!).render(<Providers><RouterProvider router={router} /></Providers>);
